module.exports = __webpack_public_path__ + "img/logo-bps.2732e6e3.png";